import { AccreditationRepository } from '../../domain/repository';
import { AccreditationRepositoryImpl } from '../repository';

export const accreditationProviders = [
  {
    provide: AccreditationRepository,
    useExisting: AccreditationRepositoryImpl,
  },
];
